import { useCallback } from 'react';
import { getPresignedS3UrlUpload } from '../config';
import useRequestCallback from './useRequestCallback';

export function usePreSignedUrlPostUploadCallback() {
  const { callback, loading, requestInstance } = useRequestCallback(
    useCallback(async (request, { fileKey, headers }) => {
      const response = await request.exec(getPresignedS3UrlUpload({ fileKey, headers }));
      const {
        configuration: { url, fields }
      } = response;
      return { url, fields };
    }, [])
  );
  return {
    callback,
    loading,
    requestInstance
  };
}

export default usePreSignedUrlPostUploadCallback;
